import React from "react";
import NotificationSystem from "react-notification-system";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Row,
  Button,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  CardImg,
} from "reactstrap";
import { FaTimes } from "react-icons/fa";
import Page from "../components/Page";
import PageSpinner from "../components/PageSpinner";
import { NOTIFICATION_SYSTEM_STYLE } from "../utils/constants";
import * as Server from "../Server";
import * as GeneralFunctions from "../GeneralFunctions";

let bannerDetails = {};
class MallPageDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      confirmationModal: false,
      mallPageDetails: {},
      categories: [],
      lowerBannerFileName: "",
      upperBannerFileName: "",
      file: {},
    };
  }

  componentDidMount() {
    this.getMallPageDetails();
  }

  getMallPageDetails = async () => {
    try {
      let user = GeneralFunctions.getAuthUser();
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: `/mallPage/details?forApp=${user.forApp}`,
        method: "GET",
      });
      if (response) {
        this.setState({
          showLoader: false,
          mallPageDetails: response.details,
          categories: response.categories,
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  handleChangeForLowerBanner = (event) => {
    const fileUploaded = event.target.files[0];
    this.setState({
      file: fileUploaded,
      lowerBannerFileName: fileUploaded.name,
    });
    event.target.value = "";
  };

  handleChangeForUpperBanner = (event) => {
    const fileUploaded = event.target.files[0];
    this.setState({
      file: fileUploaded,
      upperBannerFileName: fileUploaded.name,
    });
    event.target.value = "";
  };

  handleUploadForLowerBanner = async () => {
    if (!this.state.lowerBannerFileName) {
      this.notificationSystem.addNotification({
        message: "Select the file",
        level: "error",
      });
      return;
    }
    let formData = new FormData();
    formData.append("mallBannerImage", this.state.file);
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: `/mallPage/addLowerBanner`,
        method: "POST",
        data: formData,
      });
      if (response) {
        this.setState({ showLoader: false, file: {}, lowerBannerFileName: "" });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.getMallPageDetails();
      }
    } catch (error) {
      this.setState({ showLoader: false, file: {}, lowerBannerFileName: "" });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  handleUploadForUpperBanner = async () => {
    if (!this.state.upperBannerFileName) {
      this.notificationSystem.addNotification({
        message: "Select the file",
        level: "error",
      });
    } else {
      let formData = new FormData();
      formData.append("mallBannerImage", this.state.file);
      try {
        this.setState({ showLoader: true });
        let response = await Server.request({
          url: `/mallPage/addUpperBanner`,
          method: "POST",
          data: formData,
        });
        if (response) {
          this.setState({
            showLoader: false,
            file: {},
            upperBannerFileName: "",
          });
          this.notificationSystem.addNotification({
            message: response.message,
            level: "success",
          });
          this.getMallPageDetails();
        }
      } catch (error) {
        this.setState({ showLoader: false, file: {}, upperBannerFileName: "" });
        this.notificationSystem.addNotification({
          message: error.message,
          level: "error",
        });
      }
    }
  };

  removeBanner = async () => {
    try {
      let url =
        bannerDetails.type === "lowerBanner"
          ? `/mallPage/deleteLowerBanner?url=${bannerDetails.url}`
          : `/mallPage/deleteUpperBanner?url=${bannerDetails.url}`;
      this.setState({ showLoader: true });
      let response = await Server.request({
        url,
        method: "DELETE",
      });
      if (response) {
        this.setState({ showLoader: false });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.getMallPageDetails();
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  toggleConfirmationModal = (url, type) => {
    if (url && type) {
      Object.assign(bannerDetails, { url, type });
    }
    this.setState({ confirmationModal: !this.state.confirmationModal });
  };

  render() {
    return (
      <div>
        <PageSpinner showLoader={this.state.showLoader} />
        <Page
          title="Mall Page Details"
          breadcrumbs={[{ name: "Mall Page Details", active: true }]}
        >
          <Row>
            <Col>
              <Card className="mb-12" style={{ marginBottom: "20px" }}>
                <CardHeader>
                  <h5 style={{ margin: "auto" }}>Lower Banners :</h5>
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col md={6} style={{ margin: "0px", display: "flex" }}>
                      <label htmlFor="file">
                        <span className="btn btn-secondary">Select File</span>
                        <span style={{ marginLeft: "5px" }}>
                          {this.state.lowerBannerFileName}
                        </span>
                      </label>
                      <input
                        style={{ display: "none" }}
                        id="file"
                        type="file"
                        accept=".png,.jpg,.jpeg"
                        onChange={this.handleChangeForLowerBanner}
                      />
                    </Col>
                    <Col md={6}>
                      <Button onClick={this.handleUploadForLowerBanner}>
                        Upload the file
                      </Button>
                    </Col>
                  </Row>
                  <Row>
                    {this.state.mallPageDetails.lowerBannerUrls &&
                    this.state.mallPageDetails.lowerBannerUrls.length ? (
                      this.state.mallPageDetails.lowerBannerUrls.map(
                        (lowerBannerUrl, index) => (
                          <Col
                            key={index}
                            sm={4}
                            md={4}
                            lg={4}
                            style={{ margin: "auto 0" }}
                          >
                            <FaTimes
                              className="removeIcon"
                              onClick={() =>
                                this.toggleConfirmationModal(
                                  lowerBannerUrl,
                                  "lowerBanner"
                                )
                              }
                            />
                            <CardImg
                              key={index}
                              width="100%"
                              src={lowerBannerUrl}
                              alt=""
                              style={{ marginBottom: "20px" }}
                            />
                          </Col>
                        )
                      )
                    ) : (
                      <Label sm={4}>No Images</Label>
                    )}
                  </Row>
                </CardBody>
              </Card>
              <Card className="mb-12" style={{ marginBottom: "20px" }}>
                <CardHeader>
                  <h5 style={{ margin: "auto" }}>Upper Banners :</h5>
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col md={6} style={{ margin: "0px", display: "flex" }}>
                      <label htmlFor="file1">
                        <span className="btn btn-secondary">Select File</span>
                        <span style={{ marginLeft: "5px" }}>
                          {this.state.upperBannerFileName}
                        </span>
                      </label>
                      <input
                        style={{ display: "none" }}
                        id="file1"
                        type="file"
                        accept=".png,.jpg,.jpeg"
                        onChange={this.handleChangeForUpperBanner}
                      />
                    </Col>
                    <Col md={6}>
                      <Button onClick={this.handleUploadForUpperBanner}>
                        Upload the file
                      </Button>
                    </Col>
                  </Row>
                  <Row>
                    {this.state.mallPageDetails.upperBannerUrls &&
                    this.state.mallPageDetails.upperBannerUrls.length ? (
                      this.state.mallPageDetails.upperBannerUrls.map(
                        (upperBannerUrl, index) => (
                          <Col
                            key={index}
                            sm={4}
                            md={4}
                            lg={4}
                            style={{ margin: "auto 0" }}
                          >
                            <FaTimes
                              className="removeIcon"
                              onClick={() =>
                                this.toggleConfirmationModal(
                                  upperBannerUrl,
                                  "upperBanner"
                                )
                              }
                            />
                            <CardImg
                              key={index}
                              width="100%"
                              src={upperBannerUrl}
                              alt=""
                              style={{ marginBottom: "20px" }}
                            />
                          </Col>
                        )
                      )
                    ) : (
                      <Label sm={4}>No Images</Label>
                    )}
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <NotificationSystem
            dismissible={false}
            ref={(notificationSystem) =>
              (this.notificationSystem = notificationSystem)
            }
            style={NOTIFICATION_SYSTEM_STYLE}
          />
          {this.state.confirmationModal ? (
            <Modal
              isOpen={this.state.confirmationModal}
              toggle={(event) => this.toggleConfirmationModal()}
              className="modal-md"
            >
              <ModalHeader
                toggle={(event) => this.toggleConfirmationModal()}
              ></ModalHeader>
              <ModalBody>Are you sure you want to delete this?</ModalBody>
              <ModalFooter>
                <Button
                  color="secondary"
                  onClick={(event) => this.toggleConfirmationModal()}
                >
                  Cancel
                </Button>{" "}
                <Button
                  color="primary"
                  onClick={(event) => {
                    this.toggleConfirmationModal();
                    this.removeBanner();
                  }}
                >
                  Delete
                </Button>
              </ModalFooter>
            </Modal>
          ) : null}
        </Page>
      </div>
    );
  }
}
export default MallPageDetails;
